import { Outlet, useNavigate } from 'react-router-dom'
import AssetTabs from './components/AssetTabs/AssetTabs'
import AvailableBalanceCard from './components/BalanceCard/AvailableBalanceCard'
import LockedBalanceCard from './components/BalanceCard/LockedBalanceCard'
import TotalBalanceCard from './components/BalanceCard/TotalBalanceCard'
import useSmartAccount from 'src/common/api-clients/safe-protocol-kit/useSmartAccount'
import { useActiveAccount } from 'thirdweb/react'
import { useConnectWallet } from 'src/common/hooks/web3/useConnectWallet'
import { useEffect } from 'react'
import ProfileCard from './components/ProfileCard/ProfileCard'
import { walletRoutes } from './wallet-routes'
import { useAtomValue } from 'jotai'
import { initialLoadingAtom } from 'src/common/stores/store'
import { tradeRoutes } from '../TradePage/trade-routes'

const WalletPage = () => {
  const account = useActiveAccount()
  const { connect } = useConnectWallet()
  const navigate = useNavigate()
  const { smartAccountInfo } = useSmartAccount()
  const initialLoading = useAtomValue(initialLoadingAtom)

  useEffect(() => {
    if (!account && !initialLoading) {
      connect().then(wallet => {
        if (wallet) {
          navigate(walletRoutes.path)
        }
      })
      navigate(tradeRoutes.path)
    }
  }, [account, navigate, connect, initialLoading])

  if (!account) return null

  return (
    <div className='container px-2 sm:px-6'>
      <ProfileCard className='mb-2' />
      {smartAccountInfo ? (
        <div className='flex flex-wrap md:flex-nowrap gap-2 mb-2'>
          <TotalBalanceCard />
          <AvailableBalanceCard />
          <LockedBalanceCard />
        </div>
      ) : null}
      <div className='paper shadow-md px-2 w-full'>
        <AssetTabs className='mb-2' />
        <Outlet />
      </div>
    </div>
  )
}

export default WalletPage
